module.exports = __webpack_public_path__ + "static/media/page-last.b3ca133b.svg";